module.exports = __webpack_public_path__ + "img/PL08769.f9e1451b.png";